'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'tiny-warning';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { AccordionContext } from './accordion.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { useControllableValue } from '../../hooks/use-controllable-value.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(o = 0; o < s.length; o++)t = s[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, s = Object.keys(e);
    for(o = 0; o < s.length; o++)t = s[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const SkinEnum = {
    STANDARD: 'standard',
    COLOR_SWATCHES: 'color-swatches'
};
let l = 'Accordion';
const Accordion = renderWithRef(l, null, (o, a)=>{
    useComponentStylesLoaded(l, SWAN_STYLE_KEY_MAP.accordion);
    let { single: p = false, expandedCollapsibles: d, onRequestExpandedChange: u, defaultExpandedCollapsibles: b, children: f, purpose: O, skin: _ = 'standard', fullBleed: y = false } = o, j = _object_without_properties(o, [
        "single",
        "expandedCollapsibles",
        "onRequestExpandedChange",
        "defaultExpandedCollapsibles",
        "children",
        "purpose",
        "skin",
        "fullBleed"
    ]), m = new Set([
        'swan-vanilla-ignore',
        'swan-accordion'
    ]);
    'color-swatches' === _ && m.add(`swan-accordion-skin-${_}`), y && m.add('swan-accordion-full-bleed'), t(!(void 0 !== d && void 0 !== o.single), 'Since `expandedCollapsibles` is provided, `single` will be ignored. The values in `expandedCollapsibles` will be treated as the source of truth');
    let [w, g] = useControllableValue({
        value: d || void 0,
        onChange: u || void 0,
        defaultValue: b || {},
        defaultOnChange: (e, ...r)=>{
            let [t, o] = r;
            e((e)=>_object_spread_props(_object_spread({}, p ? {} : e), {
                    [t]: o
                }));
        }
    });
    return jsx(AccordionContext.Provider, {
        value: {
            expandedCollapsibleMap: w,
            requestExpandedChange: g,
            purpose: O
        },
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: a,
            classNames: m,
            props: _object_spread_props(_object_spread({}, j), {
                as: 'list' === O ? o.as || o.component || 'ol' : o.as
            }),
            children: f
        })
    });
});

export { Accordion, SkinEnum };
